export const sanitizeEmail = (email) => email.trim().toLowerCase();

export const isValidEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
}

export const isEmpty = (value) => value.trim() === '';
export const isValidPassword = (password) => password.length >= 8;
